module.exports = __webpack_public_path__ + "img/greengps.959561c4.png";